import { gql } from 'glimmer-apollo';
import { GAME_ARTICLE_FRAGMENT, ESPORTS_ARTICLE_FRAGMENT } from '../fragments/common';

export const ESPORTS_INDEX_QUERY = gql`
  ${ESPORTS_ARTICLE_FRAGMENT}
  
  query {
    articles: eSportsArticles(limit: 6) {
      ...ESportsArticleInfo
      body
    }
    popularPosts: eSportsArticles(limit: 4) {
      ...ESportsArticleInfo
    }
  }
`;
